import { useState } from 'react';
import { Package } from 'lucide-react';
import { fmtCurrency } from '../../lib/format.js';
import { SaleNumpad } from './sale-numpad.jsx';
import { SaleSheetShell, SellButton } from './sale-sheet-shell.jsx';
import { PriceDeltaNote } from './price-delta-note.jsx';

// Bundle-Verkauf: mehrere Artikel zu EINEM Paketpreis (eine Transaktion).
export function BundleSheet({ items, open, onOpenChange, onBundleSale, dark }) {
  const safeItems = items ?? [];
  const totalSingle = safeItems.reduce((sum, i) => sum + (i.price || 0), 0);
  const [amount, setAmount] = useState(totalSingle);

  if (!open) return null;

  return (
    <SaleSheetShell
      open={open}
      onClose={() => onOpenChange(false)}
      testId="bundle-sheet"
      title="Bundle-Verkauf"
      subtitle={<span className="num">{`${safeItems.length} Artikel · Einzelsumme ${fmtCurrency(totalSingle)}`}</span>}
      leading={
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--tint-troedel)]">
          <Package className="h-5 w-5 text-[var(--accent-troedel)]" />
        </div>
      }
      footer={
        <>
          <SaleNumpad
            tone="sale"
            prefill={totalSingle}
            caption="Paketpreis"
            onValueChange={setAmount}
            note={<PriceDeltaNote value={amount} reference={totalSingle} kind="bundle" />}
          />
          <SellButton
            amountLabel={fmtCurrency(amount)}
            disabled={!(amount > 0) || safeItems.length === 0}
            onClick={() => { if (amount > 0 && safeItems.length) onBundleSale?.(safeItems.map(i => i.id), amount); }}
          />
        </>
      }
    >
      {/* Ausgewählte Artikel */}
      <div className="mb-1 overflow-hidden rounded-[12px] bg-[var(--fill-quaternary)]">
        {safeItems.map((item, idx) => (
          <div
            key={item.id}
            className={`flex min-h-[40px] items-center gap-3 px-3.5 py-2 text-[15px] ${idx > 0 ? 'border-t border-[var(--separator)]' : ''}`}
          >
            <span className="min-w-0 flex-1 truncate">{item.name}</span>
            <span className="num shrink-0 text-[var(--label-secondary)]">{fmtCurrency(item.price || 0)}</span>
          </div>
        ))}
      </div>
    </SaleSheetShell>
  );
}
